var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCracked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7594 2.97C12.1194 3.5025 12.3294 4.14 12.3294 4.83C12.3219 6.63 10.9044 8.0925 9.11942 8.1525C9.04442 8.145 8.95442 8.145 8.87192 8.1525C7.21442 8.1 5.87192 6.8325 5.69192 5.2125C5.47442 3.285 7.05692 1.5 8.99192 1.5",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24211 10.92C3.42711 12.135 3.42711 14.115 5.24211 15.3225C7.30461 16.7025 10.6871 16.7025 12.7496 15.3225C14.5646 14.1075 14.5646 12.1275 12.7496 10.92C10.7021 9.5475 7.31961 9.5475 5.24211 10.92Z",
    stroke: "#2F4DC4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCracked);
export default __webpack_public_path__ + "static/media/user-cracked.d4e79bcf6f139c8441d6439369421bdd.svg";
export { ForwardRef as ReactComponent };